/* eslint-disable @typescript-eslint/no-explicit-any */
import { Directive, HostListener } from '@angular/core';

/**
 * CmgFocusSelectDirective - Select text of input on focus
 */
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[focusSelect]',
})
export class CmgFocusSelectDirective {
  @HostListener('onFocus', ['$event'])
  onFocus(event: any) {
    event?.target?.select();
  }
}
